import React from 'react'
import {Card, CardHeader, CardBody, Button, Col, Row } from 'reactstrap'
import { Link, } from 'react-router-dom'
import queryString from 'query-string'
import englishCongratsImg from './../../../img/english_submission.gif';
import mathCongratsImg from './../../../img/math_submission.gif';
import readingCongratsImg from './../../../img/reading_submission.gif';
import scienceCongratsImg from './../../../img/science_submission.gif';
/* AssessmentTesting

  <AssessTestResults 
    userAssessment={this.props.userAssessment}
    routeParams={this.props.routeParams}
    search={this.props.search}
  />

*/

export default function AssessTestResults(props) {
  const subtestId = props.routeParams.subTestSetId
  let uA = null
  let testDisplayName = ''
  let subTestDisplayName = ''
  let correct = ''
  let possible = ''
  let assessmentId = ''
  let timeout = false
  let scale = ''
  let completionMessage = <h4>Congratulations on completing your test!</h4>
  let congratsImg = '';
  if (props.userAssessment) {
    uA = props.userAssessment
    testDisplayName = uA.assessmentSet.name
    subTestDisplayName = uA.assessmentSubtests[subtestId].displayName
    correct = uA.scoring.bySubtest[subtestId].raw
    possible = uA.scoring.bySubtest[subtestId].possible
    assessmentId = uA.assessmentSet.id
    scale = uA.scoring.bySubtest[subtestId].scale
    if (queryString.parse(props.search).timeout) {
      timeout = true
    }
   
    if(subTestDisplayName==="English")
    {
      congratsImg = englishCongratsImg;
    }else if(subTestDisplayName==="Math")
    {
      congratsImg = mathCongratsImg;
    }else if(subTestDisplayName==="Reading")
    {
      congratsImg = readingCongratsImg;
    }else{
      congratsImg = scienceCongratsImg;
    }
  }

  if (timeout) {
    completionMessage = (
      <p>You used all of the time allowed on this test. Congratulations on
        getting through it!</p>
    )
  }

  
  return (
    <Card>
      
        <CardHeader className="assessment-test-header" style={{padding: '0px'}}>
         <h4 className="test-title">{`${testDisplayName}: ${subTestDisplayName} Test Results`}</h4>
        </CardHeader>
        <Row className="test-card-outer">
          <Col lg='3' md='4' sm='5' className="test-gif">
            <img src={congratsImg} />
          </Col>
          <Col lg='9' md='8' sm='7'>
            <CardBody className="congratulation-title">
              {completionMessage}
              <p>You answered {<span className="result-answer">{correct}</span>} correct out of {<span className="result-answer">{possible}</span>} possible.</p>
              <p>Click below to view your full results on all the tests you've taken so far.</p>
              <Link to={`/assessment/dashboard/${assessmentId}`}><Button color='primary'>Return to Dashboard</Button></Link>
            </CardBody>
          </Col>
        </Row>
    </Card>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/AssessTestResults.js